import { Box, Skeleton } from "@mui/material";
import { memo } from "react";
import { IGracePeriodCptListProps } from "./models";
import { GracePeriodCptCard } from "./GracePeriodCptCard/GracePeriodCptCard";

export const GracePeriodCptList = memo(
  ({ data, loading }: IGracePeriodCptListProps) => {
    return (
      <Box
        sx={{ display: "flex", flexDirection: "column", gap: loading ? 1 : 2 }}
      >
        {loading &&
          Array.from({ length: 3 }).map((_, index) => (
            <Skeleton
              variant="rectangular"
              sx={(t) => ({ height: 50, borderRadius: t.shape.borderRadius })}
              key={index}
            />
          ))}
        {!loading &&
          data.map((item) => (
            <GracePeriodCptCard data={item} key={item.integrationId} />
          ))}
      </Box>
    );
  }
);
